<template>
  <v-form ref="changePasswordForm" @submit.prevent="changePassword">
    <v-card-title>Change Password</v-card-title>
    <v-card-text>
      <v-text-field label="Old Password"
                    v-model="oldPassword"
                    type="password"
                    validate-on-blur
                    :rules="rules.oldPassword"
                    :error-messages="serverError.oldPassword"
                    @focus="serverError.oldPassword = ''" />
      <v-text-field label="New Password"
                    v-model="newPassword"
                    type="password"
                    validate-on-blur
                    :rules="rules.newPassword"
                    :error-messages="serverError.newPassword"
                    @focus="serverError.newPassword = ''" />
      <v-text-field label="Confirm Password"
                    v-model="confirmPassword"
                    type="password"
                    validate-on-blur
                    :rules="rules.confirmPassword" />
    </v-card-text>
    <v-card-actions class="px-4 pb-4">
      <v-btn type="submit" color="primary" large ripple>Change Password</v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import { rules } from '@/util/Helpers';

export default {
  name: 'ChangePasswordForm',
  data() {
    return {
      rules: {
        oldPassword: [
          (v) => rules.required(v, 'Please enter your current password'),
        ],
        newPassword: [
          (v) => rules.required(v, 'Please enter your new password'),
          (v) => rules.password(v),
        ],
        confirmPassword: [
          (v) => rules.required(v, 'Please confirm your new password'),
          (v) => rules.match(v, this.newPassword, 'Passwords must match'),
        ],
      },
      serverError: {
        oldPassword: '',
        newPassword: '',
      },
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      loading: false,
    };
  },
  methods: {
    async changePassword() {
      if (this.$refs.changePasswordForm.validate()) {
        try {
          this.loading = true;
          await this.$store.dispatch('post', {
            api: 'User/ChangePassword',
            data: {
              OldPassword: this.oldPassword,
              NewPassword: this.newPassword,
              ConfirmPassword: this.confirmPassword,
            },
          });
          this.$emit('snackbar', 'Password successfully changed!');
        } catch (e) {
          if (e.response.data.ModelState.errors.includes('Incorrect password.')) {
            this.serverError.oldPassword = 'Incorrect Password';
          }
        }
        this.loading = false;
      }
    },
  },
};
</script>
